<template>
  <p>Meanwhile, this paragraph is served from child component named <code>SecondParagraph</code>. We can use the component after loading the component into Vue.js instance, and calling the component in the template using <code>&lt;SecondParagraph&gt;</code> or <code>&lt;second-paragraph&gt;</code> tag.</p>
</template>

<script>
export default {
  // Don't forget to give name to the component properly
  name: 'SecondParagraph'
}
</script>